<template>
  <component :is="componentType"></component>
</template>

<script>
import PersonalPage from '@/pages/profile/PersonalPage'
import CompanyPage from '@/pages/profile/CompanyPage'

export default {
  name: 'ProfilePage',
  components: {
    PersonalPage,
    CompanyPage
  },
  computed: {
    componentType () {
      if (this.$store.state.user.currentUser.IsCompany) {
        return 'company-page'
      }
      return 'personal-page'
    }
  },
  created () {
    this.$store.dispatch('user/getCurrent')
  }
}
</script>
